import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// ?safe&utm_source=FB&country=US&area=activity-female-walking&exp=web_walking_female_risk_free_offer~1
			funnel: {
				id: 'ob-female-walking-risk-free-offer',
				locale: ['en'],
			},
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_walking_female_risk_free_offer'
					),
			},
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_walking_female_risk_free_offer'
					),
			},
		},
	},
]

export default config
